import axios, { AxiosError, AxiosResponse, CreateAxiosDefaults } from "axios";

function create(apiHost: string, config: CreateAxiosDefaults) {
  const { headers, ...rest } = config || {};
  const instance = axios.create({
    baseURL: apiHost,
    headers,
    timeout: 60000,
    withCredentials: true,
    ...rest
  });
  return instance;
}

function mergeParams(params: object, o: object) {
  return { params, ...o };
}

export default {
  create,
  mergeParams
};
